var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmCloser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0426 3.15094C19.3028 2.89073 19.3028 2.46885 19.0426 2.20864L17.8353 1.00133C17.5751 0.741123 17.1532 0.741123 16.893 1.00133L9.41895 8.47539L2.52594 1.58238C2.26573 1.32217 1.84385 1.32217 1.58364 1.58238L0.376332 2.78968C0.116123 3.04989 0.116123 3.47177 0.376331 3.73198L7.26935 10.625L0.504128 17.3902C0.243919 17.6504 0.243919 18.0723 0.504127 18.3325L1.71143 19.5398C1.97164 19.8 2.39352 19.8 2.65373 19.5398L9.41895 12.7746L16.7652 20.1209C17.0254 20.3811 17.4473 20.3811 17.7075 20.1209L18.9148 18.9136C19.175 18.6534 19.175 18.2315 18.9148 17.9713L11.5686 10.625L19.0426 3.15094Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmCloser);
export default __webpack_public_path__ + "static/media/mm-closer.1c04c80c1046cf2ec9e095d6c44bb11d.svg";
export { ForwardRef as ReactComponent };